import { render, staticRenderFns } from "./RevisionsDialog.vue?vue&type=template&id=2b6e4358&scoped=true"
import script from "./RevisionsDialog.vue?vue&type=script&lang=js"
export * from "./RevisionsDialog.vue?vue&type=script&lang=js"
import style0 from "./RevisionsDialog.vue?vue&type=style&index=0&id=2b6e4358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e4358",
  null
  
)

export default component.exports